import rovDives from "./data/lowering_metrics.json";

export const fetchDives = async () => {
  return rovDives.map((dive) => ({
    ...dive,
    radius: Math.max(
      Math.abs(dive["Max Longitude"] - dive["Min Longitude"]),
      Math.abs(dive["Max Latitude"] - dive["Min Latitude"])
    ),
    center: [
      (dive["Min Longitude"] + dive["Max Longitude"]) / 2,
      (dive["Min Latitude"] + dive["Max Latitude"]) / 2,
    ],
  }));
};

export const fetchMetrics = async (lowering: string) => {
  try {
    const metrics = await import(
      `../../public/mockROVData/reports/${lowering}/metrics.json`
    );
    return metrics.default;
  } catch (error) {
    console.error(`Error loading metrics for lowering ${lowering}:`, error);
    return null;
  }
};

export const fetchAiSummary = async (lowering: string) => {
  try {
    const ai_summary = await import(
      `../../public/mockROVData/reports/${lowering}/ai_summary.json`
    );
    return ai_summary.default;
  } catch (error) {
    console.error(`Error loading ai_summary for lowering ${lowering}:`, error);
    return null;
  }
};

export const fetchSampleDetections = async (
  lowering: string,
  phylum: string,
  startingHour: number,
  endingHour: number
) => {
  const sampleDetectionsPath = `/mockROVData/reports/${lowering}/sample_detections`;
  const files = [];

  for (let i = startingHour; i <= endingHour; i++) {
    files.push(`${sampleDetectionsPath}/${phylum}_frame_hour_${Math.floor(i)}.jpg`);
  }

  return files;
};
